export default function () {
  this.getYears()
}



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/resources/mounted.js